import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { FlowActions } from "../../stores/flowStore";
export const useAcceptOffersFlow = t0 => {
  const $ = _c(4);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    mode: t2
  } = t1;
  const mode = t2 === undefined ? "full" : t2;
  let t3;
  if ($[2] !== mode) {
    t3 = items => {
      FlowActions.startFlow({
        type: "accept-offer",
        items,
        mode
      });
    };
    $[2] = mode;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};